import React, { useEffect } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { useTheme } from "../../../utils/ThemeContext";

const SearchInput = ({ value, handleValueChange, placeholder }) => {
  const handleChange = (event) => {
    handleValueChange(event.target.value);
  };
  const { theme } = useTheme();

  return (
    <div className="flex-direction-row items-center gap-8 width-100 height-100 search-input">
      <img
        className={`pointer accreditation-input-icon`}
        width={24}
        height={24}
        src={theme === "light" ? icons.search : icons.search_dark}
        alt="search"
      />
      <input
        className="inria-sans-400 font-12 weight-300"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />

      {/* <img
        className={`accreditation-input-icon ${value === "" ? "" : "hidden"}`}
        src={icons.pen}
      /> */}
    </div>
  );
};

export default SearchInput;
